import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import './styles/main.scss'
import { initializeApp } from 'firebase/app'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyAlSKDAdEfNbBVBlb-0MGWfWrB-jDv0Hok',
  authDomain: 'pixeon-id-admin.firebaseapp.com',
  projectId: 'pixeon-id-admin',
  storageBucket: 'pixeon-id-admin.appspot.com',
  messagingSenderId: '949481105254',
  appId: '1:949481105254:web:39fea21a6de5a90d504aa7',
  measurementId: 'G-SYV78TWY25'
}

initializeApp(firebaseConfig)

const app = createApp(App)
installElementPlus(app)
app.use(store).use(router).mount('#app')
